export default typeof self !== 'undefined' && self.atob
    ? self.atob.bind(self)
    : // Accessing 'Buffer' via 'global' prevents webpack polyfilling it for web environment
        (str) => global.Buffer.from(str, 'base64').toString('utf8');
//# sourceMappingURL=atob.js.map